export const environment = {
  production: false,
  apiBaseUrl: 'https://playground.oobeya.io/api/',
  apisBaseUrl: 'https://playground.oobeya.io/apis/',
  imageBaseUrl: 'https://playground.oobeya.io/api/',
  features: new Map([
    ['profiles', true],
    ['admin', true]
  ]),
  cryptoKey: 'kD&y(@!v8~_w,FDM',
  playground: true,
  isUserGuideActive: false,
  auth: {
    google: {
      clientId: '801802922989-oovbi3i9vhfilnbmpiuf5ti7gh5fog92',
      authBaseUrl: '.apps.googleusercontent.com'
    },
    github: {
      clientId: '467ea7e50323ae1d4446',
      scope: 'user',
      authBaseUrl: 'https://github.com/login/oauth/authorize'
    },
    linkedin: {
      clientId: '77nqklyo0n3n0h',
      redirectUrl: 'https://playground.oobeya.io',
      scope: 'r_emailaddress+r_liteprofile',
      authBaseUrl: 'https://www.linkedin.com/uas/oauth2/authorization'
    },
    credentials: {
      username: 'demo.user',
      password: 'fu6VxksB'
    }
  }
};
